import { loadRemoteModule } from "@cw-elements/mfe-setup/load";
import { Layout } from "antd";
import { getDefaultWorkspace } from "app-redux/selectors/licensingAccounts.selector";
import { RoutePaths, history } from "core/history";
import { UUID } from "core/utils/BasicModels";
import React from "react";
import { useSelector } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import { useConfig, type CWElementsConfig } from "@cw-elements/config";
import { getCurrentUser } from "app-redux/selectors/accounts.selector";

export interface HierarchyMgtProps {
  workspaceId: UUID;
  getConfigInstance: () => CWElementsConfig;
  onCancel: () => void;
}

const HierarchyMgt = React.lazy(() =>
  loadRemoteModule<HierarchyMgtProps>("hierarchy-mgt/index")
);

const HierarchyMgtPage = () => {
  const defaultWorkspaceId = useSelector(getDefaultWorkspace);
  const user = useSelector(getCurrentUser);

  const currentWorkspaceId = defaultWorkspaceId ||
    user?.default_licensing_account_id;

  return (
    currentWorkspaceId ?
      <Layout.Content style={{overflow: 'auto', backgroundColor: 'white'}}>
        <React.Suspense fallback={
          <div style={{ margin: 12 }}>
            <LoadingOutlined />
          </div>
        }>
            <HierarchyMgt
              getConfigInstance={useConfig}
              workspaceId={currentWorkspaceId}
              onCancel={() => history.push({
                pathname: RoutePaths.HOME()
              })}
            />
        </React.Suspense>
      </Layout.Content>
      : null
  )
}

export default HierarchyMgtPage;